import EfSwiperTab from '@elem/ui/ef-swiper-tab';
import EfSection from '@elem/ui/ef-section';
import { useEffect, useState } from 'react';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

const CustomizedEl = ({ text }: { text: string }) => {
    return (
        <div className="m-customized-el">
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="45" viewBox="0 0 21 45" fill="none">
                <path
                    d="M9.81956 16.6939V0.315637C9.81956 0.0297948 9.42629 -0.0482553 9.31713 0.215922L0.149098 22.4032C0.0780685 22.5751 0.204426 22.764 0.390419 22.764H9.49142C9.65931 22.764 9.78357 22.9202 9.74586 23.0838L4.86774 44.2461C4.80006 44.5397 5.20115 44.6955 5.34946 44.4333L20.6685 17.3447C20.767 17.1706 20.6412 16.9551 20.4413 16.9551H10.0807C9.93647 16.9551 9.81956 16.8382 9.81956 16.6939Z"
                    fill="#30BF00"
                />
            </svg>
            <span>{text}</span>
        </div>
    );
};

export default function TheComp() {
    const { t } = useLang('theProduct.M');
    const [gap, setGap] = useState(24);

    const lists = [
        {
            tab: t('tab1_title'),
            desc: t('tab1_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1732340243502/M-pc-1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1732340242600/M-h5-1.jpg',
            customizedEl: (
                <CustomizedEl
                    text={t.rich('tab1_time', {
                        t: (tx: string) => <span className="time">{tx}</span>,
                    })}
                />
            ),
        },
        {
            tab: t('tab2_title'),
            desc: t('tab2_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1732340242959/M-pc-2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1732340243864/M-h5-2.jpg',
            customizedEl: (
                <CustomizedEl
                    text={t.rich('tab2_time', {
                        t: (tx: string) => <span className="time">{tx}</span>,
                    })}
                />
            ),
        },
        {
            tab: t('tab3_title'),
            desc: t('tab3_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1732340242776/M-pc-3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1732340243687/M-h5-3.jpg',
            customizedEl: (
                <CustomizedEl
                    text={t.rich('tab3_time', {
                        t: (tx: string) => <span className="time">{tx}</span>,
                    })}
                />
            ),
        },
        {
            tab: t('tab4_title'),
            desc: t('tab4_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1732340243140/M-pc-4.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1732340243322/M-h5-4.jpg',
            customizedEl: (
                <CustomizedEl
                    text={t.rich('tab4_time', {
                        t: (tx: string) => <span className="time">{tx}</span>,
                    })}
                />
            ),
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setGap(window?.innerWidth > 1440 ? 24 : window?.innerWidth > 1024 ? 20 : window?.innerWidth >= 768 ? 48 : 0);
        }
    }, []);

    return (
        <div className={styles.TheComp}>
            <EfSection hasAnimation={false} label={t('label')} title={t('title')} desc={t('desc')} />
            <EfSwiperTab theme="white" loop navigation={false} pagination={false} lists={lists} gap={gap} />
        </div>
    );
}
